import fetcher from '@helpers/fetcher';
import { getRefreshToken } from '@helpers/fetcher/token';

const getUrl = () => 'v7/refresh/';

/**
 * @typedef {object} v7RefreshPostResult
 * @property {string} access_token
 * @property {string} refresh_token
 */

/**
 * @returns {Promise<v7RefreshPostResult>}
 */
export async function v7RefreshPost() {
  const res = await fetcher.post(
    getUrl(),
    {},
    { headers: { Authorization: `jwt ${getRefreshToken()}` }, meta: { isRefreshToken: true } }
  );

  return res.data;
}
